
import Vue from 'vue'
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import ChatState, { Chat } from '@/store/modules/Chat';
import store from '@/store';
import SessionsModule from '../../store/modules/Sessions';
import UserModule from '../../store/modules/User';
import { polishPlurals } from "polish-plurals";

const chatModule = getModule(ChatState, store);
const sessionsModule = getModule(SessionsModule, store);
const userModule = getModule(UserModule, store);

interface SortBy {
    field: 'date'|'name';
    direction: 'asc'|'desc';
};

@Component
export default class ChatList extends Vue {

    get currentChats() {
        return chatModule.currentChats.map(chat => ({
            ...chat,
            sessionName: this.getNameForSessionId(chat.sessionId)
        })).filter(
            (chat) => !this.unreadOnly || chat.messages.some(msg => msg.author !== 'me' && !msg.isRead)
        ).sort((a, b) => {
            const value = (chat: Chat) => {
                if (this.sortBy.field === 'date') {
                    return chat.lastMessageTime || chat.creationTime;
                } else if (this.sortBy.field === 'name') {
                    return chat.clientName;
                } else {
                    return 0;
                }
            };

            if (this.sortBy.direction === 'asc') {
                return value(a) > value(b) ? 1 : -1;
            } else {
                return value(a) > value(b) ? -1 : 1;
            }
        });
    }

    get archivedChats() {
        return chatModule.archivedChats.map(chat => ({
            ...chat,
            sessionName: this.getNameForSessionId(chat.sessionId)
        }));
    }

    get sessionList() {
        return sessionsModule.sessionList[userModule.user!.id];
    }

    get unreadMessagesCount() {
        return chatModule.chats.reduce(
            (prev, curr) => 
                prev + curr.messages.filter(msg => !msg.isRead && msg.author !== 'me').length,
                0
        );
    }
    public dialog = false;
    public polishPlurals = polishPlurals;
    public sortBy: SortBy = { field: 'date', direction: 'desc' };
    public unreadOnly = false;

  openChat(chat: Chat) {
      this.$emit('chatOpened');
      chatModule.openChat(chat);
  }

  changeSorting(field: SortBy['field']) {
      if (this.sortBy.field === field) {
          this.sortBy.direction =
            this.sortBy.direction === 'asc' ? 'desc' : 'asc';
      } else {
          this.sortBy = {
              field,
              direction: 'asc',
          };
      }
  }

    private getNameForSessionId(sessionId: string) {
        const session = sessionsModule.sessions[sessionId];
        if (session) {
            return session.name;
        }
        const sessionListElement = this.sessionList.find(
            (el) => el.id === sessionId,
        );

        if (sessionListElement) {
            return sessionListElement.name;
        }

        throw new Error(`Session with id ${sessionId} not loaded`);
  }
}

